import React from 'react';
import { useParams } from 'react-router-dom';
import { Box } from 'shared/layout/Box';
import { getDriverDQFStats } from 'src/fetch/drivers';
import { Tooltip } from '@progress/kendo-react-tooltip';
import BaseToggle from 'src/shared/components/inputs/BaseToggle';

const DQFOnlyControl = (props) => {
  const [driverDQFStats, setDriverDQFStats] = React.useState(null);
  React.useEffect(() => {
    if (!!driverDQFStats || !props.sourceId) { return; }
    getDriverDQFStats(props.sourceId).then(setDriverDQFStats);
  }, [props.sourceId, driverDQFStats]);

  return (
    <Box display="flex" alignItems="center" style={{ whiteSpace: 'nowrap' }}>
      <div className="control-wrapper">
        <BaseToggle
          id="dqfOnly"
          {...props}
        />
      </div>
      &nbsp;
      {driverDQFStats && props.value && (
        <>
          <div style={{ fontSize: '1em', padding: '3px', whiteSpace: 'nowrap' }}>
            &nbsp;
            {`${driverDQFStats.numberOfDriverDQFFiles} / ${driverDQFStats.totalOfDQFFiles}`}
          </div>
          <span style={{ fontSize: '1em', padding: '5px', whiteSpace: 'normal' }}>
            {driverDQFStats.numberOfDriverDQFFiles < driverDQFStats.totalOfDQFFiles ? (
              <>
                <strong>Missing DQFs:</strong>
                {` ${driverDQFStats?.missingDQFFiles?.join?.(', ') ?? 'none'}`}
              </>
            ) : (
              <strong>All DQFs Complete</strong>
            )}
          </span>
        </>
      )}
    </Box>
  );
};
export default DQFOnlyControl;
